import { Badge, Button, cn } from "@devhop/ui";
import type { PayoutTableFilter } from "../lib/instructor-payout-display";

export type PayoutTableFilterCounts = {
  general_class: number;
  private_lesson: number;
  partner: number;
  room_rental_assist: number;
  general_class_assist: number;
  rate_issue: number;
};

type InstructorMonthlyPayoutTableFiltersProps = {
  activeFilter: PayoutTableFilter;
  onFilterChange: (filter: PayoutTableFilter) => void;
  counts: PayoutTableFilterCounts;
};

const FILTER_OPTIONS: {
  key: PayoutTableFilter;
  label: string;
  countKey?: keyof PayoutTableFilterCounts;
}[] = [
  { key: "all", label: "ທັງໝົດ" },
  { key: "general_class", label: "ຄູຫຼັກ", countKey: "general_class" },
  { key: "private_lesson", label: "ສ່ວນຕົວ", countKey: "private_lesson" },
  { key: "partner", label: "Partner", countKey: "partner" },
  {
    key: "room_rental_assist",
    label: "ຊ່ວຍສອນເຊົ່າຫ້ອງ",
    countKey: "room_rental_assist",
  },
  {
    key: "general_class_assist",
    label: "TA",
    countKey: "general_class_assist",
  },
  { key: "rate_issue", label: "ບໍ່ມີອັດຕາ", countKey: "rate_issue" },
];

export function InstructorMonthlyPayoutTableFilters({
  activeFilter,
  onFilterChange,
  counts,
}: InstructorMonthlyPayoutTableFiltersProps) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2">
      <span className="text-muted-foreground text-xs">ກັ່ນຕົວ:</span>
      {FILTER_OPTIONS.map((opt) => {
        if (opt.key === "rate_issue" && counts.rate_issue === 0) {
          return null;
        }
        const count =
          opt.countKey != null ? counts[opt.countKey] : undefined;
        const isActive = activeFilter === opt.key;

        return (
          <Button
            key={opt.key}
            type="button"
            size="sm"
            variant={isActive ? "default" : "outline"}
            className={cn(
              "h-8 gap-1.5",
              opt.key === "rate_issue" &&
                !isActive &&
                "border-amber-500/50 text-amber-800 hover:bg-amber-500/10",
            )}
            onClick={() => onFilterChange(opt.key)}
          >
            {opt.label}
            {count != null ? (
              <Badge
                variant={isActive ? "secondary" : "outline"}
                className="h-5 min-w-5 px-1 text-[10px] tabular-nums"
              >
                {count.toLocaleString("lo-LA")}
              </Badge>
            ) : null}
          </Button>
        );
      })}
      {activeFilter !== "all" ? (
        <Button
          type="button"
          size="sm"
          variant="ghost"
          className="h-8 text-muted-foreground"
          onClick={() => onFilterChange("all")}
        >
          ລ້າງກັ່ນຕົວ
        </Button>
      ) : null}
    </div>
  );
}
